/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1ExamExamitemidExamListQueryResponse,
  GetApiV1ExamExamitemidExamListPathParams,
  GetApiV1ExamExamitemidExamListQueryParams,
  GetApiV1ExamExamitemidExamList400,
  GetApiV1ExamExamitemidExamList401,
  GetApiV1ExamExamitemidExamList500,
} from "../../types/examQuestionLibraryController/GetApiV1ExamExamitemidExamList.ts";

function getGetApiV1ExamExamitemidExamListUrl(
  examItemId: GetApiV1ExamExamitemidExamListPathParams["examItemId"],
) {
  const res = {
    method: "GET",
    url: `/api/v1/exam/${examItemId}/exam-list` as const,
  };
  return res;
}

/**
 * @description Retorna a lista paginada de provas que contêm a questão informada (via OriginExamItemId). Aplica filtros de disciplina e empresa. Quando a empresa não é informada, retorna apenas provas globais (sem empresa associada). A empresa do usuário logado tem precedência sobre o filtro de empresa. **(Requer Authorization para autenticação)**
 * @summary Listar provas que contêm uma questão (Requer Authorization para autenticação)
 * {@link /api/v1/exam/:examItemId/exam-list}
 */
export async function getApiV1ExamExamitemidExamList(
  examItemId: GetApiV1ExamExamitemidExamListPathParams["examItemId"],
  params?: GetApiV1ExamExamitemidExamListQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1ExamExamitemidExamListQueryResponse,
    ResponseErrorConfig<
      | GetApiV1ExamExamitemidExamList400
      | GetApiV1ExamExamitemidExamList401
      | GetApiV1ExamExamitemidExamList500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1ExamExamitemidExamListUrl(examItemId).url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}
